import script from "./LegendUI.vue?vue&type=script&setup=true&lang=js"
export * from "./LegendUI.vue?vue&type=script&setup=true&lang=js"

import "./LegendUI.vue?vue&type=style&index=0&id=63a4859b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a4859b"]])

export default __exports__